// extracted by mini-css-extract-plugin
export default {"effect":"Effect_effect__yzKXH","explosion":"Effect_explosion__ND0bY"};